var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#7292F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H4C2.9 2 2 2.9 2 4V17C2 17.55 2.45 18 3 18C3.55 18 4 17.55 4 17V5C4 4.45 4.45 4 5 4H15C15.55 4 16 3.55 16 3C16 2.45 15.55 2 15 2ZM15.59 6.59L20.42 11.42C20.79 11.79 21 12.3 21 12.83V22C21 23.1 20.1 24 19 24H7.99C6.89 24 6 23.1 6 22L6.01 8C6.01 6.9 6.9 6 8 6H14.17C14.7 6 15.21 6.21 15.59 6.59ZM15 13H19.5L14 7.5V12C14 12.55 14.45 13 15 13Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file_copy.bd8696c46874710653653500d6620791.svg";
export { ForwardRef as ReactComponent };